import { create } from "zustand";

interface OrganizationState {
  initialized: boolean;
  currentOrganization: any;
  organizations: any[];
  pendingOrganizations: any[];
  isSwitcherShown: boolean;
  updateOrganizations: (organizations: any[]) => void;
  updatePendingOrganizations: (organizations: any[]) => void;
  selectCurrentOrganization: (organizationId: string) => void;
  initialize: () => void;
  showSwitcher: () => void;
  hideSwitcher: () => void;
}

export const useOrganizationStore = create<OrganizationState>((set) => ({
  initialized: false,
  currentOrganization: null,
  organizations: [],
  pendingOrganizations: [],
  isSwitcherShown: false,
  updateOrganizations: (organizations) => set(() => ({ organizations })),
  updatePendingOrganizations: (pendingOrganizations) =>
    set(() => ({ pendingOrganizations })),
  selectCurrentOrganization: (organizationId) => {
    set((state) => ({
      currentOrganization: state.organizations.find(
        (x) => x.id == organizationId,
      ),
    }));
  },
  initialize: () => set(() => ({ initialized: true })),
  showSwitcher: () => set(() => ({ isSwitcherShown: true })),
  hideSwitcher: () => set(() => ({ isSwitcherShown: false })),
}));
